import { render, staticRenderFns } from "./ContactFileTypeSelect.vue?vue&type=template&id=008352bf"
import script from "./ContactFileTypeSelect.vue?vue&type=script&lang=js"
export * from "./ContactFileTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports